/**
 * Sanitizes a tag key for Sentry telemetry events.
 *
 * Requirements:
 * - Maximum length of 32 characters
 * - Can contain only letters (a-zA-Z), numbers (0-9), underscores (_),
 *   periods (.), colons (:), and dashes (-)
 *
 * @param key - The tag key to sanitize
 * @returns The sanitized tag key
 */
export function sanitizeTagKey(key: string): string {
  if (!key) {
    return '';
  }

  // Remove invalid characters and keep only allowed ones
  const sanitized = key.replace(/[^a-zA-Z0-9_.:-]/g, '');

  // Truncate to maximum length of 32 characters
  return sanitized.substring(0, 32);
}

/**
 * Sanitizes a tag value for Sentry telemetry events.
 *
 * Requirements:
 * - Maximum length of 200 characters
 * - Cannot contain newline (\n) characters
 *
 * @param value - The tag value to sanitize
 * @returns The sanitized tag value
 */
export function sanitizeTagValue(value: string): string {
  if (!value) {
    return '';
  }

  // Remove newline characters
  const sanitized = value.replace(/\n/g, '');

  // Truncate to maximum length of 200 characters
  return sanitized.substring(0, 200);
}
